<template>
  <div class="app-body" ref="body">
    <div class="app-header">
      <router-link class="back" :to="'/list/'+ news.cateid">
        <van-icon name="arrow-left" />
        返回
      </router-link>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="margin-top:3rem;">
      <div v-show="!isEmpty" class="detail">
        <div class="detail-title">{{ news.title }}</div>
        <div class="detail-content" v-html="news.content"></div>
      </div>
      <div v-show="isEmpty">
        对不起，请求的信息不存在！
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppFooter
  },
  mixins: [tools],
  props: {
    id: String
  },
  data() {
    return {
      isLoading: false,
      finished: false,
      count: 0,
      page: 1,
      news: {},
      error: false,
      w: 0,
      isEmpty: false
    }
  },
  computed: {
    ...mapGetters([]),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.8) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        style = {height: (this.w * 0.68 * 0.333) + 'px'};
      }
      return style;
    }
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
  },
  activated() {
    if (!this.news || !this.news.id) {
      this.loadData();
    }
    if (!this.w) {
      this.getImgW();
    }
  },
  methods: {
    loadData(callback) {
      if (!this.id) {
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'vue/home/getById/'+ this.id,
        data: {hits: true},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.initData(json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    initData(json) {
      this.isEmpty = false;
      this.news = json || {};
      if (!json) {
        this.isEmpty = true;
      }
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        this.initData(json);
        this.$toast('刷新成功');
      });
    },
  }
}
</script>

<style lang="less" scoped>
.app-body{}
.app-header {
  position:fixed;
  top:0;
  z-index:99;
  height:3rem;
  width:100%;
  padding:.5rem .6rem .5rem 0;
  box-sizing:border-box;
  .flex-center();
  justify-content:space-between;
  .fixedapp();
  background-color:#f5f5f5;
  .shadow_black(0 1px 1px);
  .back {
    .flex-center-v();
    font-size:1rem;
    .van-icon {
      font-size:1.6rem;
    }
  }
}
.detail {
  padding:2rem;
  &-title {
    padding-left:1rem;
    .fontsize(1.25rem);
    color:#3b8dd1;
    text-align:center;
  }
  &-content {
    margin-top:2rem;
    margin-bottom:2rem;
    .fontsize(1rem);
    line-height:1.85;

  }
}
</style>